'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = require('./config.js');

var _config2 = _interopRequireDefault(_config);

var _VBIManager = require('./VBIManager');

var _VBIManager2 = _interopRequireDefault(_VBIManager);

require('./util/PolyFill.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VBI = function VBI(config_) {
  this.fullConfig = Object.assign({}, _config2.default, config_);
};

VBI.prototype.registerObject = function (player, options) {
  var plData = {
    acc: options.accountId,
    pid: options.eventId,
    userid: options.userId,
    ptype: options.eventType,
    iip: options.ipAddress.internalIpAddress
  };
  new _VBIManager2.default(this.fullConfig, player, options.type, plData);
};

VBI.prototype.destroyObject = function () {};

exports.default = VBI;